import { trackMenuEvent } from "utils/trackEvent";
import reservationApi from "../services/reservations";
import { AxiosError } from "axios";

// res-api sends a 200 with errors b/c of mobile
type CartResult = {
  data?: {
    errors?: Array<{
      detail: string;
    }>;
  };
};

export const addReservation = ({
  cartId,
  menuItemId,
  quantity,
  variant,
  forceUpdate,
}: {
  cartId: string;
  menuItemId: number;
  quantity: number;
  variant: any;
  forceUpdate: boolean;
}) => {
  return reservationApi
    .post(
      `/cart_items`,
      {
        cartItem: {
          menuItemId: menuItemId,
          variantId: variant.id,
          quantity: quantity,
          packageUnit: variant.cartUnit,
          packageSize: variant.cartQuantity,
          packagePrice: variant.price,
          medical: variant.medical,
        },
        dataApiVersion: "v3",
        forceUpdate,
      },
      {
        headers: {
          "X-Leafly-Id": cartId,
        },
      }
    )
    .then((response) => {
      const { data } = response as CartResult;

      if (data && data.errors) {
        throw data.errors[0] && data.errors[0].detail;
      }

      return data;
    })
    .catch((error: AxiosError | string) => {
      if (typeof error !== "string") {
        if (error?.response?.status === 422) {
          // This happens if a menu item can't be found by res api.
          // It usually means that the dispensary's menu is stale.
          const relevantInfo = {
            menuItemId: menuItemId,
            variantId: variant.id,
            errorMessage: error.response.data,
          };
          trackMenuEvent(
            "Add to Bag",
            "Click",
            "Error",
            relevantInfo,
            null,
            null
          );
        }

        throw error?.response?.data;
      }

      throw error;
    });
};
